<template>
   <div class="right">
      <div class="title-box">
        <span @click="tabClick(i)" :class="index == i?'curr':''" v-for="(item,i) in tabs" :key="i">{{item}}</span>
      </div>
      <div class="content">
        <div class="tab-box1" v-if="index == 0">
          <h3>中国服务贸易协会信息技术服务委员会</h3>
          <h4>第一条</h4>
          <p>
            为适应我国经济与社会发展，推动我国标准化事业的改革进程，依据《中华人民共和国标准化法》《团体标准管理规定》《中国服务贸易协会信息技术服务委员会章程》等有关规定，为规范管理，促进团体标准健康有序发展，委员会制定本办法。
          </p>

          <h4>第二条</h4>
          <p>
            为满足市场和创新需要，由委员会协调相关市场主体共同制定，并统一管理、发布实施，供社会自愿采用的规范性文件。
          </p>

          <h4>第三条</h4>
          <p>
            委员会秘书处，配合总会完成相关工作。
          </p>

          <h4>第四条</h4>
          <p>
            团体标准的制定，遵循开放、透明、公平的原则，吸纳生产者、经营者、使用者、消费者、教育科研机构、检测及认证机构、政府部门等相关方代表参与，充分反映各方的共同需求。
          </p>

          <h4>第五条</h4>
          <p>
            团体标准的制定以满足市场和创新需要为目标，聚焦新技术、新产业、新业态和新模式，结合当前信息技术服务行业发展的热点、难点，填补标准空白。
          </p>

          <h4>第六条</h4>
          <p>
            及时吸纳专利和科技创新成果，科学合理利用资源，推广科学技术成果，促进科学技术成果市场化、产业化，提升市场主体核心竞争力，提高经济效益、社会效益、生态效益，做到技术上先进、经济上合理。
          </p>

          <h4>第七条</h4>
          <p>标准的范围：</p>
          <div>
            <p>
              （一）目前信息技术服务行业亟待发展且现有相关标准体系未涉及和覆盖的领域；
            </p>
            <p>
              （二）与信息技术服务行业密切相关且与其他非本行业学科交叉的领域；
            </p>
            <p>
              （三）信息技术服务行业中满足市场和创新需求的跨界多学科技术集成的新产品、新技术；
            </p>
            <p>
              （四）上述领域中相关的基础标准和方法标准等。
            </p>
          </div>


          <h4>第八条</h4>
          <p>
            标准及相关研究成果纳入委员会的创新成果奖励范围。标准化工作业绩应作为有关资质和评定的条件之一。
          </p>

          <h4>第九条</h4>
          <p>
            标准制修订经费由标准编制单位和参加单位共同承担，同时接受社会团体、企事业单位或个人的赞助。
          </p>

          <h4>第十条</h4>
          <p>
            为保证标准的适宜性、充分性和有效性等，委员会秘书处与标委会、编制单位等每年应组织不少于一次的跟踪反馈，结合标准实施的监督检查结果进行标准修订完善。
          </p>

          <h4>第十一条</h4>
          <p>中国服务贸易协会信息技术服务委员会的主管机构，具有决策职能。</p>
          <p>主管机构主要职责包括：</p>
          <div>
            <p>
              （一）负责标委会及其秘书处的设立；
            </p>
            <p>
              （二）贯彻落实国家标准化工作的法律、行政法规、方针和政策，对标准化活动相关的政策、制度和标准化文件的通过进行决策；
            </p>
            <p>
              （三）组织制定和实施标准化战略规划、计划，建立标准体系；
            </p>
            <p>
              （四）负标准立项、批准、发布、出版，并指导标准的宣贯、培训、实施工作；
            </p>
            <p>
              （五）对标准的制修订及实施推广等工作进行监督管理；
            </p>
            <p>
              （六）负责标准化的表彰奖励工作，组织研究成果的奖励申报工作；
            </p>
            <p>
              （七）积极参与国际标准化活动，推进团体标准国际化。
            </p>
          </div>

          <h4>第十二条</h4>
          <p>标委会是中国服务贸易协会信息技术委员会标准化工作的技术归口和管理协调组织，由行业各领域资深专家以及标准化专家等组成，主要职责包括：</p>
          <div>
            <p>
              （一）负责根据专业类别不同，组建分技术领域的专家团队；
            </p>
            <p>
              （二）负责标准体系的制定、修订，协助编制标准化规划、计划；
            </p>
            <p>
              （三）负责标准的提案、技术审查、编号、复审等工作，提出相关的意见及建议；
            </p>
            <p>
              （四）协调组织和指导标准的制修订工作；
            </p>
            <p>
              （五）组织技术咨询工作，承担T/CTES标准实施、监督情况的调查分析工作；
            </p>
            <p>
              （六）负责标准的解释；
            </p>
            <p>
              （七）指导并协调标准化工作的开展，解决标准编制中出现的争议；
            </p>
            <p>
              （八）组织标准化学术、经验交流和研讨等；
            </p>
            <p>
              （九）开展与其他单位的沟通与合作，积极参与国际和国内外各层面标准化机构的活动。
            </p>
          </div>

          <h4>第十三条</h4>
          <p>
            信息技术服务行业各领域的企事业单位、科研院所等具有独立法人资格的机构和特邀专家，均可参加标准的制定，根据需求承担相应的标准编制工作；标准编制单位应在相应领域内具有较高水平；标委会秘书处会同编制单位组建标准编写小组，编写小组的构成应符合利益相关方代表均衡的原则，并报标委会批准。
            编制单位按照本办法及相关要求，对标准编制的质量和进度全面负责。
          </p>
        </div>
        <div class="tab-box1" v-else>
          <h3>中国服务贸易协会信息技术服务委员会团体标准编制工作流程</h3>
          <p>中国服务贸易协会信息技术服务委员会团体标准编制工作分为：标准申请、立项、起草、征求意见、审核、报批公示、批准发布等全流程管理。</p>
          <div class="liucheng">
            <span class="title">团体标准制订工作程序</span>
            <img src="@/assets/img/liuchengtu.png" alt="">
          </div>
        </div>
      </div>
   </div>
</template>
<script>
export default {
  data() {
    return {
      index: 0,
      tabs: [
        '管理办法',
        '研制流程'
      ]
    }
  },
  methods: {
    tabClick(i) {
      this.index = i
    }
  }
};
</script>
<style lang="less" scoped>

.right {
  width: 905px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  .list {
    .item {
      padding: 30px 0;
      border-bottom: 1px solid #f8f8fb;
      img {
        width: 274px;
        height: 142px;
        margin-right: 58px;

      }
      h3 {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #171717;
        line-height: 30px;
      }
      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5F5F6A;
        line-height: 24px;
        margin-top: 13px;
      }
    }
  }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #f8f8fb;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    cursor: pointer;
    &.curr {
      color: #1b252c;
      &::after {
        width: 96px;
        height: 2px;
        background: #0d53bc;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}

.tab-box1 {
  .liucheng {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #171717;
      line-height: 30px;
      margin-top: 60px;
      margin-bottom: 18px;
    }
  }
  h3 {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #171717;
    line-height: 30px;
    padding-top: 28px;
  }
  h4 {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #171717;
    line-height: 30px;
    margin-top: 30px;
  }
  p {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5F5F6A;
    line-height: 28px;
    margin-bottom: 30px;
    margin-top: 20px;
  }
}
</style>
